import JSZip from 'jszip';
import SHA256 from 'crypto-js/sha256';
import FileSaver from "file-saver";
import {nanoid} from 'nanoid';
import apiService from '../../services/api.service';
import firebaseService from '../../services/firebase.service';

// action types
export const TIMEPROOF_DOWNLOAD_PDF = 'timeproofDownloadPdf';
export const TIMEPROOF_TIMESTAMP_PDF = 'timeproofTimestampPdf';
export const DELETE_TIMEPROOF_REPORT = 'deleteTimeproofReport';


// mutation types
const SET_REPORTS = 'setReports';


const mutations = {
   [SET_REPORTS](state, reports) {
      state.reports = reports;
   },
};

const actions = {
   [TIMEPROOF_TIMESTAMP_PDF](context) {
      return new Promise((resolve, reject) => {
         let formdata = new FormData;
         formdata.append('pdf_url', context.getters.reportFields.source);
         apiService.post('/pdf/timestamp', formdata).then((res) => {
            context.getters.reportFields.uid = context.getters.user.uid;
            context.getters.reportFields.user = context.getters.user.name;
            context.getters.reportFields.email = context.getters.user.email;
            context.getters.reportFields.captured_file = res.data.url;
            context.getters.reportFields.captured_file_id = res.data.id;
            context.getters.reportFields.captured_file_hash = SHA256(`${res.data.url}_${nanoid()}`).toString().substr(0, 25);
            resolve(res.data);
         }).catch((err) => {
            reject(`[timeproofTimestampPdf] => ${err}`)
         });
      });
   },
   [TIMEPROOF_DOWNLOAD_PDF](context, id) {
      return new Promise((resolve, reject) => {
         let files = [
            {name: 'timeproof.pdf', url: `/timeproof/${id}`},
            {name: 'certtificate.pdf', url: `/certificate/${id}`}
         ];

         let zip = new JSZip();
         const promises = [];
         files.forEach((item) => {
            const promise = apiService.setPdfDownloadAsBaseUrlNew(item.url).then((arraybuffer) => {
               zip.file(item.name, arraybuffer);
            }).catch((err) => {
               reject(`[timeproofDownloadPdfFromServer] => ${err}`)
            });
            promises.push(promise);
         });

         Promise.all(promises).then(() => {
            zip.generateAsync({type: "blob"}).then(content => {
               FileSaver.saveAs(content, "file.zip");
               resolve(true);
            });
         });
      });
   },
   [DELETE_TIMEPROOF_REPORT](context, {id, source_id, captured_file_id}) {
      return new Promise((resolve, reject) => {
         firebaseService.deleteReport(id).then(() => {
            let files = [
               {id: source_id},
               {id: captured_file_id}
            ];

            const promises = [];
            files.forEach((item) => {
               apiService.setPdfApiAsBaseUrl();
               const promise = apiService.post('/pdf/delete', {"pub_id": item.id}).then(() => {
                  promises.push(promise);
               }).catch((err) => {
                  reject(`[deleteTimeproof] => ${err}`)
               });
            });

            Promise.all(promises).then(() => {
               const reports = context.getters.reports;
               context.commit(SET_REPORTS, reports.filter((el) => el.id !== id));
               resolve(true);
            });
         }).catch((err) => {
            reject(`[deleteReport] => ${err}`)
         });
      });
   },
};

export default {
   actions,
   mutations
}

